import React from "react";

//ANT DESIGN IMPORTS
import { Card, Col, Divider, Row, Typography, Table } from "antd";

//ANT DESIGN ICONS IMPORTS
import { labelConfig } from "../../../../customer.config";

const { Text } = Typography;

const Preview = (props) => {
  const { formData, currencyData, templateProdDetail, chargeTableSource, customerInfo } = props;

  console.log(formData);
  const data = {
    details: [
      {
        name: "Customer Name",
        value: customerInfo ? customerInfo.entityName : "-",
      },
      {
        name: "Product Name",
        value: formData?.details?.productId
          ? templateProdDetail?.productOptions?.find(
              (item) => item.id === formData.details.productId
            ).name
          : "-",
      },
      {
        name: "Submitted On",
        value: formData?.details?.submittedOnDate ? formData.details.submittedOnDate : "-",
      },
      {
        name: "Account Officer",
        value: formData?.details?.fieldOfficerId
          ? templateProdDetail?.fieldOfficerOptions?.find(
              (item) => item.id === formData.details.fieldOfficerId
            ).displayName
          : "-",
      },
    ],

    terms: [
      {
        name: labelConfig.currency,
        value: `${currencyData.name ? currencyData.name : ""}${
          currencyData.code ? ` (${currencyData.code})` : " - "
        }`,
      },
      {
        name: labelConfig.decimalPlaces,
        value: `${currencyData.decimalPlaces ? currencyData.decimalPlaces : "-"}`,
      },
      {
        name: labelConfig.currencyInMultiplesOf,
        value: `${currencyData.inMultiplesOf ? currencyData.inMultiplesOf : " - "}`,
      },
      {
        name: labelConfig.norminalAnnualInterest,
        value: String(formData?.terms?.nominalAnnualInterestRate)
          ? formData?.terms?.nominalAnnualInterestRate
          : "-",
      },
      {
        name: labelConfig.interestCompoundingPeriod,
        value: formData?.terms?.interestCompoundingPeriodType
          ? templateProdDetail?.interestCompoundingPeriodTypeOptions?.find(
              (item) => item.id === formData?.terms?.interestCompoundingPeriodType
            )?.value
          : "-",
      },
      {
        name: labelConfig.interestPostingPeriod,
        value: formData?.terms?.interestPostingPeriodType
          ? templateProdDetail?.interestPostingPeriodTypeOptions?.find(
              (item) => item.id === formData?.terms?.interestPostingPeriodType
            )?.value
          : "-",
      },
      {
        name: labelConfig.interestCalculatedUsing,
        value: formData?.terms?.interestCalculationType
          ? templateProdDetail?.interestCalculationTypeOptions?.find(
              (item) => item.id === formData?.terms?.interestCalculationType
            )?.value
          : "-",
      },
      {
        name: labelConfig.daysInYear,
        value: formData?.terms?.interestCalculationDaysInYearType
          ? templateProdDetail?.interestCalculationDaysInYearTypeOptions?.find(
              (item) => item.id === formData.terms.interestCalculationDaysInYearType
            )?.value
          : "-",
      },
      {
        name: labelConfig.minimumOpeningBalance,
        value: formData?.terms?.minRequiredOpeningBalance
          ? formData?.terms?.minRequiredOpeningBalance
          : "-",
      },
      {
        name: labelConfig.lockInPeriod,
        value: formData?.terms?.lockinPeriodFrequency
          ? formData?.terms?.lockinPeriodFrequency
          : "-",
      },
      {
        name: labelConfig.lockinPeriodFrequencyType,
        value: String(formData?.terms?.lockinPeriodFrequencyType)
          ? templateProdDetail?.lockinPeriodFrequencyTypeOptions?.find(
              (item) => String(item.id) === String(formData.terms.lockinPeriodFrequencyType)
            )?.value
          : "-",
      },
      {
        name: labelConfig.applyWithdrawalFeeForTransfers,
        value: formData?.terms?.withdrawalFeeForTransfers ? "True" : "False",
      },
      {
        name: labelConfig.isOverdraftAllowed,
        value: formData?.terms?.allowOverdraft ? "True" : "False",
      },
      {
        name: labelConfig.maxOverdraftAmountLimit,
        value: formData?.terms?.overdraftLimit ? formData?.terms?.overdraftLimit : "-",
      },
      {
        name: labelConfig.nominalAnnualInterestForOverdraft,
        value: formData?.terms?.nominalAnnualInterestRateOverdraft
          ? formData?.terms?.nominalAnnualInterestRateOverdraft
          : "-",
      },
      {
        name: labelConfig.minOverdraftRequiredForInterestCalculation,
        value: formData?.terms?.minOverdraftForInterestCalculation
          ? formData?.terms?.minOverdraftForInterestCalculation
          : "-",
      },
      {
        name: labelConfig.isLienAllowed,
        value: formData?.terms?.lienAllowed ? "True" : "False",
      },
      {
        name: labelConfig.maximumLienAmountLimit,
        value: formData?.terms?.maxAllowedLienLimit ? formData?.terms?.maxAllowedLienLimit : "-",
      },
      {
        name: labelConfig.enforceMinimumBalance,
        value: formData?.terms?.enforceMinRequiredBalance ? "True" : "False",
      },

      {
        name: "Minimum balance",
        value: formData?.terms?.minRequiredBalance ? formData?.terms?.minRequiredBalance : "-",
      },
    ],
  };

  const columns = [
    [
      {
        key: " 1",
        title: "Name",
        dataIndex: "name",
      },
      {
        key: " 2",
        title: "Type",
        dataIndex: "type",
      },
      {
        key: " 3",
        title: "Amount",
        dataIndex: "amount",
      },
      {
        key: " 4",
        title: "Collected On",
        dataIndex: "collectedOn",
      },
      {
        key: " 5",
        title: "Date",
        dataIndex: "feeOnMonthDay",
      },
      {
        key: "6",
        title: "Repayments Every",
        dataIndex: "collectedOn",
      },
    ],
  ];

  return (
    <Card
      style={{
        marginBottom: "2%",
        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
      }}
    >
      {/* DETAILS FORM  */}
      <div
        style={{
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          marginBottom: 25,
        }}
      >
        <Divider orientation="left" orientationMargin="0">
          {"Details"}
        </Divider>
        {data.details.map((detail, index) => {
          const { name, value } = detail;

          return (
            <div
              style={{
                border: "2px solid #F5F5F5",
                borderRadius: 15,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomColor: "#E2E2E2",
              }}
              key={index}
            >
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 15,
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    borderBottomLeftRadius: 0,
                  }}
                >
                  <Text strong>{name}</Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Text style={{ color: "#b8b8b8" }}>{value}</Text>
                </Col>
              </Row>
            </div>
          );
        })}
      </div>

      {/* TERMS FORM  */}
      <div
        style={{
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          marginBottom: 25,
        }}
      >
        <Divider orientation="left" orientationMargin="0">
          {"Terms"}
        </Divider>
        {data.terms.map((detail, index) => {
          const { name, value } = detail;

          return (
            <div
              style={{
                border: "2px solid #F5F5F5",
                borderRadius: 15,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomColor: "#E2E2E2",
              }}
              key={index}
            >
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 15,
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    borderBottomLeftRadius: 0,
                  }}
                >
                  <Text strong>{name}</Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Text style={{ color: "#b8b8b8" }}>{value}</Text>
                </Col>
              </Row>
            </div>
          );
        })}
      </div>

      {/* CHARGES FORM */}
      <div
        style={{
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          marginBottom: 25,
        }}
      >
        <Divider orientation="left" orientationMargin="0">
          {"Charges"}
        </Divider>
        <Table pagination={false} columns={columns[0]} dataSource={chargeTableSource} />
      </div>
    </Card>
  );
};

export default Preview;
